// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalOverlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(14, 36, 99, 0.55);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  opacity: 0;
  transition: opacity 0.3s ease-in;
  pointer-events: none;
  z-index: 30;
}

.modalOverlay.active {
  transition-delay: 0.5s;
  opacity: 1;
  pointer-events: all;
}

.modalItself {
  position: relative;
  margin-top: 12rem;
  /* Keeps the modal off the screen edges on narrow phones. */
  margin-left: 1rem;
  margin-right: 1rem;
  min-width: 20rem;
  max-width: 32rem;
  background-color: var(--white);
  padding: 1.5rem 2rem 1.5rem 2.25rem;
  border-radius: 16px;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.35);
  transform: scale(0.7);
  transition: transform 0.3s linear;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.9rem;
  color: var(--ink);
  text-align: center;
  overflow: hidden;
}

.modalItself::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  background: var(--pink);
}

.modalOverlay.instant.active {
  transition-delay: 0s;
}

.active .modalItself {
  transform: scale(1);
  transition-timing-function: var(--bounce-effect);
}

.modalItself p {
  margin-top: 0;
}

.modalTitle {
  margin: 0;
  font-size: 2.05rem;
  line-height: 1.15;
}

.modalSubtitle {
  margin: 0.35rem 0 0;
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.modalOverlay:has(.playAgain) {
  align-items: center;
}

.modalItself.playAgain {
  max-width: 38rem;
  min-width: 28rem;
  margin-top: 0;
  max-height: calc(100vh - 2.5rem);
  overflow-y: auto;
  padding: 1.75rem 1.6rem 1.5rem 1.85rem;
}

.modalItself .roundTypePicker {
  margin: 1.1rem 0 1.2rem;
  font-size: 1rem;
  font-family: var(--font-body);
}

.modalButtons {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.modalButtons button {
  white-space: nowrap;
  margin: 0;
  min-width: 8.5rem;
}

.modalItself.playAgain .modalButtons button:last-child {
  flex: 1;
  max-width: 14rem;
}

@media (max-width: 600px) {
  .modalItself.playAgain {
    min-width: unset;
    max-width: 32rem;
    padding: 1.4rem 1.2rem 1.25rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,gCAAgC;EAChC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2DAA2D;EAC3D,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;EAC3C,qBAAqB;EACrB,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;EACvC;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(14, 36, 99, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  opacity: 0;\n  transition: opacity 0.3s ease-in;\n  pointer-events: none;\n  z-index: 30;\n}\n\n.modalOverlay.active {\n  transition-delay: 0.5s;\n  opacity: 1;\n  pointer-events: all;\n}\n\n.modalItself {\n  position: relative;\n  margin-top: 12rem;\n  /* Keeps the modal off the screen edges on narrow phones. */\n  margin-left: 1rem;\n  margin-right: 1rem;\n  min-width: 20rem;\n  max-width: 32rem;\n  background-color: var(--white);\n  padding: 1.5rem 2rem 1.5rem 2.25rem;\n  border-radius: 16px;\n  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.35);\n  transform: scale(0.7);\n  transition: transform 0.3s linear;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.9rem;\n  color: var(--ink);\n  text-align: center;\n  overflow: hidden;\n}\n\n.modalItself::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  background: var(--pink);\n}\n\n.modalOverlay.instant.active {\n  transition-delay: 0s;\n}\n\n.active .modalItself {\n  transform: scale(1);\n  transition-timing-function: var(--bounce-effect);\n}\n\n.modalItself p {\n  margin-top: 0;\n}\n\n.modalTitle {\n  margin: 0;\n  font-size: 2.05rem;\n  line-height: 1.15;\n}\n\n.modalSubtitle {\n  margin: 0.35rem 0 0;\n  font-family: var(--font-body);\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--ink-soft);\n}\n\n.modalOverlay:has(.playAgain) {\n  align-items: center;\n}\n\n.modalItself.playAgain {\n  max-width: 38rem;\n  min-width: 28rem;\n  margin-top: 0;\n  max-height: calc(100vh - 2.5rem);\n  overflow-y: auto;\n  padding: 1.75rem 1.6rem 1.5rem 1.85rem;\n}\n\n.modalItself .roundTypePicker {\n  margin: 1.1rem 0 1.2rem;\n  font-size: 1rem;\n  font-family: var(--font-body);\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.modalButtons button {\n  white-space: nowrap;\n  margin: 0;\n  min-width: 8.5rem;\n}\n\n.modalItself.playAgain .modalButtons button:last-child {\n  flex: 1;\n  max-width: 14rem;\n}\n\n@media (max-width: 600px) {\n  .modalItself.playAgain {\n    min-width: unset;\n    max-width: 32rem;\n    padding: 1.4rem 1.2rem 1.25rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
